module.exports = __webpack_public_path__ + "img/ico-relation.5efd309f.svg";